import React, { createContext, useState, useEffect, useCallback } from "react";
import { techCardsAPI } from "src/shared/api/techCardsAPI";

export const TechCardContext = createContext();

export const TechCardProvider = ({ children, token }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const refreshData = useCallback(async () => {
    console.log("Starting refreshData with token:", token);
    setLoading(true);
    try {
      const response = await techCardsAPI.getItemsWithDetails({ token });
      console.log("API Response:", response.data);
      const responseData = response.data.result || response.data || [];
      console.log("Parsed response data:", responseData);

      const dataWithItemsCount = responseData.map((techCard) => ({
        ...techCard,
        items_count: techCard.items ? techCard.items.length : 0,
        created_at: techCard.created_at || new Date().toISOString(),
      }));

      setData(dataWithItemsCount);
      console.log("Tech cards loaded:", dataWithItemsCount);
    } catch (error) {
      console.error("Error in refreshData:", error);
      console.error("Error response:", error.response?.data);
      try {
        const fallbackResponse = await techCardsAPI.getItems({ token });
        const fallbackData = fallbackResponse.data.result || fallbackResponse.data || [];
        setData(fallbackData.map((item) => ({ ...item, items_count: 0 })));
        console.log("Fallback data loaded:", fallbackData);
      } catch (fallbackError) {
        console.error("Fallback failed:", fallbackError);
      }
    } finally {
      setLoading(false);
      console.log("RefreshData completed, loading:", loading);
    }
  }, [token, setData, setLoading, loading]);

  useEffect(() => {
    if (token) {
      refreshData();
    } else {
      console.warn("No token provided to TechCardProvider");
    }
  }, [token, refreshData]);

  return (
    <TechCardContext.Provider value={{ token, data, loading, refreshData }}>
      {children}
    </TechCardContext.Provider>
  );
};